// File: CustomerOrderTypePage.jsx
import React, { useRef } from 'react';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { ConfirmDialog } from 'primereact/confirmdialog';
import CustomerOrderTypeTable from './components/CustomerOrderTypeTable';
import CustomerOrderTypeForm from './components/CustomerOrderTypeForm';
import useCustomerOrderType from './hooks/useCustomerOrderType';
import CustomerOrderTypeFilter from './components/CustomerOrderTypeFilter';
import { useLanguage } from '../../../../contexts/LanguageContext';

const CustomerOrderTypePage = () => {
    const { th } = useLanguage();
    
    const {
        toast,
        tableProps,
        formProps,
        dialogVisible,
        filterFields,
        customFilterTypes,
        customFilterOptions,
        handleSearch,
        handleResetFilters,
        handleApplyFilters,
        deleteConfirmationVisible,
        setDeleteConfirmationVisible,
        deleteOrderType,
        setDialogVisible,
        openNewDialog
    } = useCustomerOrderType();

    const handleDialogHide = () => {
        setDialogVisible(false);
    };

    const columnsRef = useRef(null);

    return (
        <div className="card">
            <Toast ref={toast} />
            <ConfirmDialog
                visible={deleteConfirmationVisible}
                onHide={() => setDeleteConfirmationVisible(false)}
                message={th('customer.deleteConfirmation')}
                header={th('common.confirm')}
                icon="pi pi-exclamation-triangle"
                accept={deleteOrderType}
                reject={() => setDeleteConfirmationVisible(false)}
                acceptLabel={th('common.yes')}
                rejectLabel={th('common.no')}
            />

            <div className="flex justify-content-between align-items-center mb-4">
                <h1 className="m-0">{th('customer.orderType')}</h1>
                <Button label={th('customer.orderType')} icon="pi pi-plus" onClick={openNewDialog} />
            </div>

            <CustomerOrderTypeFilter
                filterFields={filterFields}
                columns={columnsRef.current}
                customFilterTypes={customFilterTypes}
                customFilterOptions={customFilterOptions}
                handleSearch={handleSearch}
                handleApplyFilters={handleApplyFilters}
                handleResetFilters={handleResetFilters}
            />

            <CustomerOrderTypeForm {...formProps} visible={dialogVisible} onHide={handleDialogHide} />

            <CustomerOrderTypeTable {...tableProps} />
        </div>
    );
};

export default CustomerOrderTypePage;
